var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon24Vk = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.7653 4.2653C3.5 5.5306 3.5 7.56707 3.5 11.64V12.36C3.5 16.4329 3.5 18.4694 4.7653 19.7347C6.0306 21 8.06706 21 12.14 21H12.86C16.9329 21 18.9694 21 20.2347 19.7347C21.5 18.4694 21.5 16.4329 21.5 12.36V11.64C21.5 7.56707 21.5 5.5306 20.2347 4.2653C18.9694 3 16.9329 3 12.86 3H12.14C8.06706 3 6.0306 3 4.7653 4.2653ZM6.5 8.5C6.59636 13.1823 9.05576 16 13.1095 16H13.3446V13.3213C14.821 13.4712 15.9219 14.5749 16.3714 16H18.5C17.9225 13.8682 16.4253 12.6895 15.4948 12.2392C16.4246 11.6823 17.7406 10.3321 18.0505 8.5H16.114C15.7076 9.98991 14.4988 11.3401 13.3439 11.4683V8.5H11.3764V13.6967C10.179 13.397 8.61709 11.9395 8.55309 8.5H6.5Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon24Vk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Icon24Vk.6dc15f0ba4804cf5a7391e18005a8507.svg";